import React, { useState } from 'react';
import './MicroPyAccordion.scss';
import { IconHour, IconSemiArrowDown, IconSemiArrowUp, IconUser } from '../Icons';
import { GatsbyImage } from 'gatsby-plugin-image';

import ArduinoNano from '../../assets/Micropython/ArduinoNanoESP32.svg';
import ArduinoNanoScrewTerminal from '../../assets/Micropython/ArduinoNanoScrewTerminal.svg';

interface MicroPythonAccordionProps {
  pyData: any;
  images: any;
  descriptions: any;
}

export default function MicroPyAccordion({ pyData, images, descriptions }: MicroPythonAccordionProps): React.ReactElement {
  const Item = ({ item }: any) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
      <>
        <div className="py-accordion__item" onClick={() => setIsOpen(!isOpen)}>
          <div>
            <h3>{item.category}</h3>
            <p>
              {item.category === 'Courses'
                ? descriptions.edges[0].node.childMdx.frontmatter.description
                : descriptions.edges[1].node.childMdx.frontmatter.description}
            </p>
          </div>
          <div className="py-accordion__icon">{isOpen ? <IconSemiArrowDown /> : <IconSemiArrowUp />}</div>
        </div>
        {isOpen && (
          <div className="py-accordion__links">
            {item.nestedChildren.map((child) => {
              return (
                <a key={child.url} className="py-accordion__link" href={child.url}>
                  {child.image && (
                    <div className="py-accordion__image">
                      <GatsbyImage alt={`hero`} objectFit="cover" imgStyle={{ objectFit: 'cover' }} image={child.image.gatsbyImageData} />
                    </div>
                  )}
                  <div className="py-accordion__content">
                    <div>
                      <h4>{child.title}</h4>
                      <p>{child.description}</p>
                    </div>
                    <div className="py-accordion__metadata">
                      <span className="py-accordion__metadata--author">
                        <IconUser /> {child.author}
                      </span>
                      <span>
                        <IconHour />{' '}
                        {new Date(child.date).toLocaleString([], {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                        })}
                      </span>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        )}
      </>
    );
  };

  return (
    <section className="py-accordion">
      <h2>MicroPython 101</h2>
      <p>
        Explore the world of Arduino and MicroPython with the MicroPython 101 course, using the{' '}
        <a href="https://store.arduino.cc/products/nano-esp32">Arduino Nano ESP32</a>.
      </p>
      {pyData[1].nestedCategories.map((accordion) => {
        return <Item key={accordion.category} item={accordion} />;
      })}
      <div className="py-accordion__hardware">
        <h3>Required Hardware</h3>
        <p>For this course, you will need the following material:</p>
        <div className="py-accordion__cards">
          <a className="py-accordion__card" href="https://store.arduino.cc/products/nano-esp32">
            <img src={ArduinoNano} alt="Arduino Nano" /> <h4>Arduino Nano ESP32</h4>
          </a>
          <a className="py-accordion__card" href="https://store.arduino.cc/products/nano-screw-terminal">
            <img src={ArduinoNanoScrewTerminal} alt="Arduino Nano Screw Terminal" /> <h4>Arduino Nano Screw Terminal</h4>
          </a>
        </div>
      </div>
    </section>
  );
}
